import { Provider } from '../entities/provider';
import { Reducer } from 'redux';
import { ISetProvider, TProvider } from '../actions/provider.action';

export type IProviderState = Provider;
export const defaultProvider = {};

export const providerReducer: Reducer<IProviderState> = (
  state: IProviderState = defaultProvider,
  action: ISetProvider
): IProviderState => {
  switch (action.type) {
    case TProvider.SET_PROVIDER:
      return action.payload[0];
  }
  return state;
};
